module.exports = __webpack_public_path__ + "static/hands-08621dddb7b1fea0cbb651e480490b86.svg";